import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'

import s from './HeaderSubNavItemTitle.scss'


const HeaderSubNavItemTitle = (props) => {
  const {
    children, className, title, to, toOLD, isActive, linkId,
    onClick, dataTestId, role,
  } = props

  const navItemTitleClassName = cx(s.title, className, {
    [s.active]: isActive,
  })

  if (to || toOLD) {
    return (
      <Link
        className={navItemTitleClassName}
        activeClassName={s.active}
        to={to}
        toOLD={toOLD}
        id={linkId}
        customColor
        onClick={onClick}
        role={role}
        dataTestId={dataTestId}
      >
        {children || <FormattedMessage {...title} />}
      </Link>
    )
  }

  if (children) {
    return (
      <span className={navItemTitleClassName} id={linkId} onClick={onClick} role={role}>
        {children}
      </span>
    )
  }

  return (
    <FormattedMessage
      className={navItemTitleClassName}
      tagId={linkId}
      {...title}
      onClick={onClick}
      dataTestId={dataTestId}
      role={role}
    />
  )
}


export default HeaderSubNavItemTitle
